<script lang="ts" setup>
import { PropType } from 'vue'
import ShipParameterTableRow from '@/components/ship-importer/ShipParameterTableRow.vue'

const props = defineProps({
  ship: { type: Object, required: true },
  fields: { type: Object as PropType<Record<string, any>>, required: true },
  tableHeight: { type: Number, default: 60 }
})

const ship = toRef(props, 'ship')

const getUnit = (param: any): string => {
  const label = props.fields[param]?.label
  let unit = '-'
  if (label.includes('[')) {
    unit = label.split('[')[1].split(']')[0]
  }
  return unit
}

const getRowValue = (param: string | null): { text: string; unit: string; value: any } | null => {
  if (!param) return null
  const label = props.fields[param]?.label
  const text = label ? label.split('[')[0] : ''
  const unit = getUnit(param)
  const value = ship.value[param]
  return { text, unit, value }
}

const tableRowFields: (string | null)[] = [
  'main_engine_number',
  'main_engine_diameter',
  'main_engine_distance_between',
  'main_engine_distance_tip_keel',
  'main_engine_distance_ship_stern',
  null,
  'transverse_thruster_number',
  'transverse_thruster_diameter',
  'transverse_thruster_distance_between',
  'transverse_thruster_distance_tip_keel',
  'transverse_thruster_duct_length'
]
</script>

<template>
  <v-table class="overflow-auto" density="comfortable" hover>
    <thead>
      <tr>
        <th style="width: 2%" class="pl-0"></th>
        <th class="text-center border-top-grey pl-0" style="width: 58%">Relevant Parameter</th>
        <th class="text-center border-left-grey border-top-grey" style="width: 20%">Unit</th>
        <th class="text-center border-left-grey border-top-grey" style="width: 20%">Value</th>
      </tr>
    </thead>
    <tbody v-if="ship" class="text-center fill-height">
      <ShipParameterTableRow
        v-for="(field, idx) in tableRowFields"
        :key="idx"
        :data="getRowValue(field)"
      />
      <tr>
        <td colspan="48" style="height: 3px"></td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr>
        <td colspan="8" style="text-align: center">No data available</td>
      </tr>
    </tbody>
  </v-table>
</template>

<style scoped>
th {
  text-align: center;
}
</style>
